// Marketplace Filters Component
// Feature: 006-marketplace-management
// Updated: 007-cloudflare-migration - removed client-side fraud analysis (now via API)

import { useTranslation } from 'react-i18next';
import type { MarketplaceItemStatus, CategoryOption } from '@/types/marketplaceAdmin';

interface MarketplaceFiltersProps {
  statusFilter: MarketplaceItemStatus | 'all';
  categoryFilter: string;
  categories: CategoryOption[];
  onStatusFilterChange: (status: MarketplaceItemStatus | 'all') => void;
  onCategoryFilterChange: (categoryId: string) => void;
}

export function MarketplaceFilters({
  statusFilter,
  categoryFilter,
  categories,
  onStatusFilterChange,
  onCategoryFilterChange,
}: MarketplaceFiltersProps) {
  const { t } = useTranslation('marketplaceAdmin');

  return (
    <div className="space-y-6">
      {/* Status Filter */}
      <div>
        <label htmlFor="status-filter" className="block text-sm font-medium text-neutral-700 mb-2">
          {t('filters.status')}
        </label>
        <select
          id="status-filter"
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value as MarketplaceItemStatus | 'all')}
          className="w-full px-4 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-sm"
        >
          <option value="all">{t('filters.allStatuses')}</option>
          <option value="active">{t('filters.active')}</option>
          <option value="expired">{t('filters.expired')}</option>
          <option value="deleted">{t('filters.deleted')}</option>
        </select>
      </div>

      {/* Category Filter */}
      <div>
        <label htmlFor="category-filter" className="block text-sm font-medium text-neutral-700 mb-2">
          {t('filters.category')}
        </label>
        <select
          id="category-filter"
          value={categoryFilter}
          onChange={(e) => onCategoryFilterChange(e.target.value)}
          className="w-full px-4 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-sm"
        >
          <option value="all">{t('filters.allCategories')}</option>
          {categories.map((category) => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
